import { createSelector } from 'reselect'
import sessionTypes from 'helpers/enums/sessionTypes'

const getInteractiveVideoSessionType = state => state.interactiveVideo.sessionType

export default createSelector(
	getInteractiveVideoSessionType,
	interactiveVideoSessionType => interactiveVideoSessionType === sessionTypes.HOMEWORK
)
